<template>
  <v-dialog :persistent="persistent" v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Distribution.Fields.logistic_info") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text>
<!--        <ValidationObserver ref="observer">-->
          <v-container>
            <v-row align="center" dense>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.logistics_company") + $t("Global.colon")}}
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="logisticsName"
                  single-line
                  readonly
                />
              </v-col>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.train_number") + $t("Global.colon")}}
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="trainNumber"
                  single-line
                  readonly
                />
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="2" class="text-right">
                {{ $t("Distribution.Fields.linkman") + $t("Global.colon") }}
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="logisticsLinkMan"
                  single-line
                  readonly
                />
              </v-col>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.contact_number") + $t("Global.colon")}}
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="contactMethod"
                  single-line
                  readonly
                />
              </v-col>
            </v-row>
            <v-row align="start" dense>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.logistic_code") + $t("Global.colon")}}
              </v-col>
              <v-col cols="9">
                <!-- <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Distribution.Fields.logistic_code')"
                  rules="required"
                > 去除物流单号必填 -->
                <v-textarea
                  outlined
                  v-model="logisticsCode"
                  readonly
                  :placeholder="$t('Distribution.logisticCodePlaceholder')"
                ></v-textarea>
                <!-- </ValidationProvider> -->
              </v-col>
            </v-row>
            <v-row align="start" dense>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.logistics_img") + $t("Global.colon")}}
              </v-col>
              <v-col cols="3" v-for="(img, i) in album" :key="i">
                <v-img :src="img" width="140" height="100" @click.stop="$showFullscreenImages([img])" />
              </v-col>
            </v-row>
          </v-container>
<!--        </ValidationObserver>-->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
// import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
  name: "LogisticAlert",

  props: {
    value: Boolean,
    persistent: Boolean,
    distribution: Object,
  },

  components: {
    // ValidationObserver,
    // ValidationProvider,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    dialog: false,
    logisticsName: "",
    logisticsCode: "",
    logisticsLinkMan: "",
    contactMethod: "",
    trainNumber: "",
    album: []
  }),

  methods: {},

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        this.logisticsName = "";
        this.logisticsCode = "";
        this.logisticsLinkMan = "";
        this.contactMethod = "";
        this.trainNumber = "";
        if (!this.dialog) {
          this.$emit("close");
          this.album = [];
        } else {
          if (this.distribution) {
            this.album = this.distribution.logistics_img_url? this.distribution.logistics_img_url : [];
            this.logisticsName = this.distribution.logistics_name ? this.distribution.logistics_name : "";
            this.logisticsCode = this.distribution.logistics_code ? this.distribution.logistics_code : "";
            this.logisticsLinkMan = this.distribution.logistics_link_man ? this.distribution.logistics_link_man : "";
            this.contactMethod = this.distribution.contact_method ? this.distribution.contact_method : "";
            this.trainNumber = this.distribution.train_number ? this.distribution.train_number : "";
          }
        }
      },
    },
    logisticsCode: {
      handler() {
        this.logisticsCode = this.logisticsCode.replace(";", "\n");
      },
    },
  },
};
</script>
